import { render, staticRenderFns } from "./OfferStakeholders.vue?vue&type=template&id=120429e4"
import script from "./OfferStakeholders.vue?vue&type=script&lang=js"
export * from "./OfferStakeholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports